"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _layout = _interopRequireDefault(require("@/layout"));
/* Layout */
var _default = exports.default = {
  'layout': _layout.default,
  'Layout': _layout.default,
  'sysconfig': function sysconfig() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/sysconfig'));
    });
  },
  'business': function business() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/business'));
    });
  },
  'lookup': function lookup() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/lookup'));
    });
  },
  'interfaceinfo': function interfaceinfo() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/interfaceInfo'));
    });
  },
  'interfaceuser': function interfaceuser() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/interfaceuser'));
    });
  },
  'role': function role() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/role'));
    });
  },
  'sysuser': function sysuser() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/sysUser'));
    });
  },
  'functionlist': function functionlist() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/functionList'));
    });
  },
  'menulist': function menulist() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/menuList'));
    });
  },
  'userClassification': function userClassification() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/functionModule/userClassification'));
    });
  },
  'apiLog': function apiLog() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/logModule/apiLog'));
    });
  },
  'callLog': function callLog() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/logModule/callLog'));
    });
  },
  'loginLog': function loginLog() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/logModule/loginLog'));
    });
  }
};